// Recovered compiled webpack factory 55939. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return u;
      },
    }));
  let r = n(28140),
    o = n(95155),
    l = r._(n(12115)),
    d = r._(n(74841)),
    i = {
      400: "Bad Request",
      404: "This page could not be found",
      405: "Method Not Allowed",
      500: "Internal Server Error",
    };
  function s(e) {
    let { req: t, res: n, err: r } = e;
    return {
      statusCode: n && n.statusCode ? n.statusCode : r ? r.statusCode : 404,
      hostname: window.location.hostname,
    };
  }
  let a = {
    error: {
      fontFamily:
        'system-ui,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji"',
      height: "100vh",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    desc: { lineHeight: "48px" },
    h1: {
      display: "inline-block",
      margin: "0 20px 0 0",
      paddingRight: 23,
      fontSize: 24,
      fontWeight: 500,
      verticalAlign: "top",
    },
    h2: { fontSize: 14, fontWeight: 400, lineHeight: "28px" },
    wrap: { display: "inline-block" },
  };
  class u extends l.default.Component {
    render() {
      let { statusCode: e, withDarkMode: t = !0 } = this.props,
        n = this.props.title || i[e] || "An unexpected error has occurred";
      return (0, o.jsxs)("div", {
        style: a.error,
        children: [
          (0, o.jsx)(d.default, {
            children: (0, o.jsx)("title", {
              children: e
                ? e + ": " + n
                : "Application error: a client-side exception has occurred",
            }),
          }),
          (0, o.jsxs)("div", {
            style: a.desc,
            children: [
              (0, o.jsx)("style", {
                dangerouslySetInnerHTML: {
                  __html:
                    "body{color:#000;background:#fff;margin:0}.next-error-h1{border-right:1px solid rgba(0,0,0,.3)}" +
                    (t
                      ? "@media (prefers-color-scheme:dark){body{color:#fff;background:#000}.next-error-h1{border-right:1px solid rgba(255,255,255,.3)}}"
                      : ""),
                },
              }),
              e ? (0, o.jsx)("h1", { className: "next-error-h1", style: a.h1, children: e }) : null,
              (0, o.jsx)("div", {
                style: a.wrap,
                children: (0, o.jsxs)("h2", {
                  style: a.h2,
                  children: [
                    this.props.title || e
                      ? n
                      : (0, o.jsxs)(o.Fragment, {
                          children: [
                            "Application error: a client-side exception has occurred",
                            " ",
                            !!this.props.hostname &&
                              (0, o.jsxs)(o.Fragment, {
                                children: ["while loading ", this.props.hostname],
                              }),
                            " ",
                            "(see the browser console for more information)",
                          ],
                        }),
                    ".",
                  ],
                }),
              }),
            ],
          }),
        ],
      });
    }
  }
  ((u.displayName = "ErrorPage"),
    (u.getInitialProps = s),
    (u.origGetInitialProps = s),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
